import { createSlice } from "@reduxjs/toolkit";

const toggleSlice = createSlice({
    name: "toggle",
    initialState: {
        open: true
    },
    reducers: {
        toggle: (state, action) => {
            state.open = action.payload;
        },
    }
});

export const { toggle } = toggleSlice.actions;
export default toggleSlice.reducer;